/**
 * Order utility functions for Sales Orders management.
 */

/**
 * Checks whether an order is an Agency Customer order (đơn bán buôn cho khách hàng là Đại lý)
 * vs a Retail Customer order (đơn bán lẻ cho Khách lẻ).
 *
 * NOTE:
 * When an agency (e.g. Vmake) sells to a retail customer (khách lẻ):
 * - order.customer_type is 'END_USER'
 * - order.end_user / order.end_user_id represents the retail customer
 * - order.agency_id is set to the selling agency (Vmake)
 *
 * Such orders must NOT be treated as agency customer orders and must NOT be added
 * to the dealer's aggregated debt!
 */
export const isAgencyCustomerOrder = (order) => {
  if (!order) return false;

  const cType = order.customer_type || order.customerType;
  if (cType === 'END_USER') return false;
  if (cType === 'AGENCY') return true;

  // If order has retail end-user info, it is definitely a retail order
  if (order.end_user_id || order.end_user) return false;

  // Fallback for legacy orders where customer_type is missing:
  const agId = order.agency_id || order.agency?.id;
  if (!agId) return false;

  const agName = (order.agency?.name || '').trim().toLowerCase();
  const custName = (order.customer_name || order.customerName || '').trim().toLowerCase();

  // If order has an explicit customer name that differs from the agency name, it's a retail order
  if (custName && agName && custName !== agName) {
    return false;
  }

  // If no retail customer indicator exists and agency is present
  return true;
};
